import React, { FC, useState, ReactNode } from 'react';
import classNames from 'classnames';
import { isTouchDevice } from '../../../utils/domUtils';
import { Hyperlink } from '../../../components/Hyperlink';
import styles from './entity_block_line_hover_hyperlink.module.scss';

type Props = {
  url?: string;
  source: string;
  children: (isHovered: boolean) => ReactNode;
};

export const EntityBlockLineHoverHyperlink: FC<Props> = ({
  children,
  url,
  source,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Hyperlink
        className={classNames(styles.link, {
          [styles.touch]: isTouchDevice(),
        })}
        href={url}
        source={source}
      >
        {children(isHovered)}
      </Hyperlink>
    </div>
  );
};
